/* eslint-disable */
export default {
  noResultFoundFor: '找不到以下的結果',
  foundFromServerHint: '輸入關鍵字並按 Enter 鍵以在 {appName} 中搜尋',
  notResultFoundFromServer: '找不到結果',
  loading: '正在載入...',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"foundFromServerHint"@#@ @source: @#@"Type keyword and press Enter to search in {appName}"@#@
// @key: @#@"notResultFoundFromServer"@#@ @source: @#@"No results found"@#@
// @key: @#@"loading"@#@ @source: @#@"loading..."@#@
